(function certificateFindControllerDefinition() {
    'use strict';

    angular.module('CertificateRRHH')
        .controller('CertificateRRHHFindController', [
            '$q', '$filter', '$scope', '$state', 'errorsExtend', 'processService', 'configViewService', '$translate', 'storageService', 'fileDownloader', 'authExtend', 'certificateService',
            function certificateRRHHFindController($q, $filter, $scope, $state, errors, processService, configViewService, $translate, storageService, fileDownloader, authExtend, certificateService) {
                $translate(['PaginationNext', 'PaginationPrev', 'PaginationFirstFem', 'PaginationLastFem'])
                    .then(function (translated) {
                        $scope.paginatorTranslations = {
                            nextText: translated.PaginationNext,
                            previousText: translated.PaginationPrev,
                            lastText: translated.PaginationLastFem,
                            firstText: translated.PaginationFirstFem
                        };
                    });

                $scope.accordionState = {
                    isOpen: true
                };

                $scope.createFilters = function () {
                    var idOu = $scope.find.organizationalUnit ? $scope.find.organizationalUnit.id : undefined;

                    var filters = {
                        name: $scope.find.name,
                        processTypeId: $scope.find.processType.id,
                        organizationalUnitId: idOu,
                        processStatesIds: [],
                        metadatas: [],
                        dateFrom: $scope.find.dateFrom,
                        dateTo: $scope.find.dateTo,
                        itemPerPage: $scope.data.itemPerPage,
                        page: $scope.data.currentPage
                    };

                    $scope.find.showNoData = false;

                    $scope.find.processType.metadatas.forEach(function (meta) {
                        filters.metadatas.push(meta);
                    });

                    if ($scope.find.selectedStates && $scope.find.selectedStates.length > 0) {
                        $scope.find.selectedStates.forEach(function (state) {
                            filters.processStatesIds = filters.processStatesIds.concat(state.ids);
                        });
                    } else {
                        $scope.find.processType.states.forEach(function (state) {
                            filters.processStatesIds = filters.processStatesIds.concat(state.ids);
                        });
                    }

                    return filters;
                }

                $scope.executeFind = function () {
                    var filters = $scope.createFilters();

                    return processService.advancedGet(filters).then(function (result) {
                        $scope.certificates = [];
                        $scope.data.totalItems = result.count;
                        $scope.data.from = 1 + ($scope.data.itemPerPage * ($scope.data.currentPage - 1));
                        result.values.forEach(function (value) {
                            var r = value;
                            r.metadatas = [];

                            $scope.find.processType.headers.forEach(function (header) {
                                var metadataFound = $filter('filter')(value.metadataValues, { systemName: header.systemName }, true);
                                if (metadataFound && metadataFound.length != 0) {
                                    r.metadatas.push({ value: metadataFound[0].value, type: metadataFound[0].type, mask: header.mask });
                                } else {
                                    r.metadatas.push({ value: null, type: null, mask: null });
                                }
                            });

                            $scope.certificates.push(r);
                        });

                        if ($scope.certificates.length == 0) {
                            $scope.find.showNoData = true;
                        }

                        if ($scope.certificates.length > 0) {
                            $scope.accordionState.isOpen = false;
                            $scope.find.showResult = true;
                            $scope.fillAccordion();
                        }
                    }, function (error) {
                        errors.showError(error);
                    });
                };

                $scope.findAction = function () {
                    if (!$scope.certificateRRHHFind.$valid) {
                        $scope.certificateRRHHFind.$setSubmitted();
                        errors.showError('VerifyFormData');
                        return false;
                    }

                    storageService.setCertificatesFilter($scope.find);
                    $scope.loadActions();

                    return $scope.executeFind();
                };

                $scope.add = function () {
                    $state.go('certificate-rrhh-add');
                };

                $scope.view = function (cert) {
                    $state.go('certificate-rrhh-detail', { id: cert.id });
                };

                $scope.edit = function (key) {
                    var certificates = $filter('filter')($scope.certificates, function (item) {
                        return item.check;
                    });

                    if (key === 'requestRenovation') {
                        if (certificates.length == 0) {
                            errors.showWarning('CertificateSelectItemWarning');
                            return false;
                        }

                        $scope.loading = true;
                        $scope.data.success = 0;
                        $scope.data.total = certificates.length;
                        $scope.data.legajos = '';

                        var promise = $q.all([]);

                        angular.forEach(certificates, function (item) {
                            var renovable = true;

                            angular.forEach(item.metadataValues, function (m) {
                                if (m.systemName === '_wfFechaVencimientoCert') {
                                    var expirationDate = new Date(m.value);
                                    if (expirationDate.setDate(expirationDate.getDate() - 30) >= today()) {
                                        renovable = false;
                                    }
                                }
                            });

                            if (renovable) {
                                promise = promise.finally(function () {
                                    return checkOut(item).then(modifyAndCheckIn);
                                });
                            }
                        });

                        promise.finally(function () {
                            $scope.loading = false;
                            if ($scope.data.certificados) {
                                $scope.data.certificados = $scope.data.certificados.slice(0, -2);
                            }

                            if ($scope.data.success === $scope.data.total) {
                                errors.showSuccess('CertificateRenovationResult', 'InfoTitle', { data: $scope.data });
                            } else {
                                errors.showWarning('CertificateRenovationResult', { data: $scope.data });
                            }

                            $scope.executeFind();
                        });
                    }
                };

                $scope.editAll = function (key) {
                    if (key === 'requestRenovation') {
                        var certificates = $scope.certificates;
                        $scope.loading = true;
                        $scope.data.success = 0;
                        $scope.data.total = certificates.length;
                        $scope.data.legajos = '';

                        var promise = $q.all([]);

                        angular.forEach(certificates, function (item) {
                            var renovable = true;

                            angular.forEach(item.metadataValues, function (m) {
                                if (m.systemName === '_wfFechaVencimientoCert') {
                                    var expirationDate = new Date(m.value);
                                    if (expirationDate.setDate(expirationDate.getDate() - 30) >= today()) {
                                        renovable = false;
                                    }
                                }
                            });

                            if (renovable) {
                                promise = promise.finally(function () {
                                    return checkOut(item).then(modifyAndCheckIn);
                                });
                            }
                        });

                        promise.finally(function () {
                            $scope.loading = false;
                            if ($scope.data.certificados) {
                                $scope.data.certificados = $scope.data.certificados.slice(0, -2);
                            }

                            if ($scope.data.success === $scope.data.total) {
                                errors.showSuccess('CertificateRenovationResult', 'InfoTitle', { data: $scope.data });
                            } else {
                                errors.showWarning('CertificateRenovationResult', { data: $scope.data });
                            }

                            $scope.executeFind();
                        });
                    }
                };

                $scope.loadPreFilters = function () {
                    if (!$scope.find.processType) {
                        var found = $filter('filter')($scope.processTypes, { preSelected: true }, true);
                        $scope.find.processType = angular.copy(found[0] || $scope.processTypes[0]);
                    }

                    $scope.find.selectedStates = $filter('filter')($scope.find.processType.states, { preSelected: true }, true);
                };

                $scope.selectProcessType = function (processType) {
                    $scope.find.processType = angular.copy(processType);
                    $scope.certificates = [];
                    $scope.find.showResult = false;
                    $scope.data = {
                        currentPage: 1,
                        totalItems: 0,
                        itemPerPage: 15,
                        from: 0
                    }
                    $scope.loadPreFilters();
                };

                $scope.cleanFilters = function () {
                    $scope.accordionState.isOpen = true;

                    storageService.clearCertificatesFilter();

                    $scope.find = storageService.getCertificatesFilter();
                    $scope.certificates = [];

                    $scope.data = {
                        currentPage: 1,
                        totalItems: 0,
                        itemPerPage: 15,
                        from: 0
                    }

                    $scope.actions = {
                        delete: false,
                        edit: false,
                        functions: []
                    };

                    $scope.loadPreFilters();

                    angular.forEach($scope.processTypes, function (item) {
                        if (item.id === $scope.find.processType.id) {
                            $scope.find.processType.metadatas = angular.copy(item.metadatas);
                        }
                    });
                };

                $scope.fillAccordion = function () {
                    $scope.certificates.forEach(function (certificate) {
                        var accordionIsOpen = false;
                        Object.defineProperty(certificate, "accordionIsOpen", {
                            get: function () { return accordionIsOpen; },
                            set: function (newValue) {
                                if (event.target.id !== "options" && !(event.target.offsetParent !== null && event.target.offsetParent.id === "options")) {
                                    if (event.target.offsetParent !== null && event.target.offsetParent.offsetParent.id === "p") {
                                        accordionIsOpen = newValue;
                                    }
                                }
                            }
                        });
                    });
                };

                $scope.exportToExcel = function () {
                    return $translate(['DocumentOrganizationalUnits', 'ProcessReceptionDateView', 'ProcessState', 'User', 'ProcessName'])
                        .then(function (translated) {
                            var headers = [];
                            var filters = $scope.createFilters();
                            filters.itemPerPage = null;
                            filters.page = null;

                            headers.push({ key: "OrganizationalUnitName", value: translated.DocumentOrganizationalUnits });

                            $scope.find.processType.headers.forEach(function (header) {
                                headers.push({ key: header.systemName, value: header.label });
                            });

                            headers.push({ key: "StateAlias", value: translated.ProcessState });

                            return processService.exportToXLS(filters, headers, 'Certificados').then(function (result) {
                                var d = new Date();

                                var docName = "Certificados";

                                var success = fileDownloader.saveAs(result.value, docName +
                                    '_' +
                                    d.getUTCFullYear() +
                                    '-' +
                                    (d.getUTCMonth() + 1) +
                                    '-' +
                                    d.getDate() +
                                    '.xlsx');

                                if (!success) {
                                    errors.showError('Api failed');
                                }

                            }, function (error) {
                                errors.showError('Api failed');
                            });
                        });
                };

                $scope.selectProcessType = function (processType) {
                    $scope.find.processType = angular.copy(processType);
                    $scope.certificates = [];
                    $scope.find.showResult = false;
                    $scope.data = {
                        currentPage: 1,
                        totalItems: 0,
                        itemPerPage: 15,
                        from: 0
                    }
                    $scope.loadPreFilters();
                };

                $scope.loadMetadata = function (item) {
                    var processType = {
                        name: item.name,
                        id: item.processTypeId,
                        preSelected: item.preSelected,
                        states: item.groupStates,
                        metadatas: [],
                        headers: []
                    };

                    item.metadatas.forEach(function (metadata) {
                        if (metadata.searchCriteria) {
                            processType.metadatas.push({
                                idObject: item.name.replace(/ /g, '_') + metadata.systemName,
                                metadataId: metadata.metadataId,
                                metadataValueFrom: undefined,
                                metadataValueTo: undefined,
                                metadataSearchTypeFrom: undefined,
                                metadataSearchTypeTo: undefined,
                                metadataType: metadata.metadataType.toLowerCase(),
                                metadataSystemName: metadata.systemName,
                                metadataLabel: metadata.searchCriteria.name,
                                metadataReadOnly: !metadata.searchCriteria.isEditable,
                                metadataEnabled: true,
                                metadataOptions: metadata.metadataOptionValues,
                                maskOptions: metadata.metadataMaskOption,
                                order: metadata.searchCriteria.order
                            });
                        }

                        if (metadata.resultCriteria) {
                            processType.headers.push({ label: metadata.resultCriteria.name, systemName: metadata.systemName, order: metadata.resultCriteria.order, mask: metadata.resultCriteria.mask });
                        }

                    });

                    processType.metadatas.sort(function (a, b) {
                        return a.order - b.order;
                    });

                    processType.headers.sort(function (a, b) {
                        return a.order - b.order;
                    });

                    processType.states.sort(function (a, b) {
                        return a.order - b.order;
                    });

                    $scope.processTypes.push(processType);
                };

                $scope.loadViewOptions = function () {
                    var defered = $q.defer();
                    var promise = defered.promise;

                    if ($scope.processTypes && $scope.processTypes.length > 0) {
                        defered.resolve();
                    } else {
                        configViewService.getById("CPPCertificateRRHH").then(function (result) {
                            if (result.processTypes && result.processTypes.length > 0) {
                                $scope.processTypes = [];
                                angular.forEach(result.processTypes, function (item) {
                                    $scope.loadMetadata(item);
                                });
                            }

                            defered.resolve();
                        }, function (error) {
                            errors.showError(error);
                            defered.reject();
                        });
                    }

                    return promise;
                };

                $scope.checkUnCheckAll = function () {
                    if ($scope.certificates.length > 0) {
                        $scope.certificates.forEach(function (c) {
                            c.check = $scope.checkAll;
                        });
                    }
                };

                $scope.loadActions = function () {
                    $scope.actions = {
                        delete: false,
                        edit: false,
                        functions: {}
                    };

                    if ($scope.find.selectedStates && $scope.find.selectedStates.length > 0) {
                        $scope.find.selectedStates.forEach(function (item) {
                            if (item.actions) {
                                for (var p in item.actions) {
                                    if (p == 'requestRenovation') {
                                        $scope.actions.functions[p] = item.actions[p];
                                    }
                                }
                            }
                        });
                    }
                };

                $scope.load = function () {
                    $scope.loading = false;
                    $scope.checkAll = false;

                    $scope.data = {
                        currentPage: 1,
                        totalItems: 0,
                        itemPerPage: 15,
                        from: 0
                    }

                    $scope.find = storageService.getCertificatesFilter();

                    $q.all([$scope.loadViewOptions(), certificateService.getProviders(0, authExtend.getOrganizationId())]).then(function (result) {
                        var encodeProviderConfig = $filter('filter')(result[1], { name: 'Encode' }, true);
                        $scope.canAddCertificate = authExtend.isInRole('CERTIFICATE START') && encodeProviderConfig.length > 0;

                        $scope.loadPreFilters();
                        $scope.loadActions();
                        $scope.executeFind();
                    });
                };

                $scope.load();

                var checkOut = function (certificate) {
                    return processService.checkout(certificate.id).then(function (result) {
                        var preexistente = $filter('filter')(result.metadataValues, { systemName: '_eExiste' }, true);

                        if (preexistente.length > 0) {
                            preexistente[0].value = true;
                        }

                        return result;
                    }, function (error) {
                        $scope.data.legajos += certificate.metadataValues[0] + ', ';
                    });
                },
                    modifyAndCheckIn = function (certificate) {
                        return processService.modifyAndSend(certificate).then(function (result) {
                            if (result) {
                                $scope.data.success++;
                            }
                        });
                    };
            }]);
})();